export const searchBar = () => {
  const form = document.querySelector('#search-block-form')
  const container = document.querySelector('.popin_search_on_site .result_container')
  form.addEventListener('submit', async (e) => {
    container.innerHTML = '<p>Recherche en cours ...</p>'
    e.preventDefault()
    const lang = document.querySelector('html').getAttribute('lang')
    const inputValue = document.querySelector('.popin_search_on_site .form-search').value
    const url = `/custom-search/api?keys=${inputValue}&language=${lang}&search=search`
    const data = await fetch(url)
    const htmlResult = await data.text()

    container.innerHTML = htmlResult
  })
}
